<!-- Modal Form ADD Customer -->
<ng-template #dialogAddCustomer let-c="close" let-d="dismiss">
  <div class="p-3">
    <div class="d-flex justify-content-between">
      <div class="logo"></div>
      <div class="close-button" (click)="d('Cross click')"></div>
    </div>
    <p class="text-header-modal">New {{subcustomer ? "Subcustomer" : "Customer" }}</p>
    <div class="modal-body">
      <form #customerForm="ngForm" (ngSubmit)="sendCustomer(customerForm)" class="form-vehicle">

        <div class="form-group">
          <label translate>customer.fullName</label>
          <input type="text" #name="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="name.invalid && name.touched" name="name">
        </div>

        <div class="form-group">
          <label translate>global.phone</label>
          <input type="text" appAllownumbersonly #phone="ngModel" autocomplete="off" ngModel class="form-control" name="phone">
        </div>

        <div class="form-group">
          <label translate>Info email</label>
          <input type="email" #infoEmail="ngModel" autocomplete="off" ngModel class="form-control" name="infoEmail">
        </div>

        <div *ngIf="this.currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
          <div class="w-100">
            <p>Allow {{subcustomer ? "subcustomer" : "customer" }} to create subcustomers?</p>
          </div>
          <div style="position: relative;" class="row">
            <div class="choose-window">
              <p>Off</p>
              <label class="switch">
                <input type="checkbox" name="allowChilds" ngModel>
                <span class="slider round"></span>
              </label>
              <p>Allow</p>
            </div>
          </div>
        </div>

        <div *ngIf="this.currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
          <div class="w-100">
            <p>Allow {{subcustomer ? "subcustomer" : "customer" }} to go in minus?</p>
          </div>
          <div style="position: relative;" class="row">
            <div class="choose-window">
              <p>Off</p>
              <label class="switch">
                <input type="checkbox" name="allowNegativeCredits" ngModel>
                <span class="slider round"></span>
              </label>
              <p>Allow</p>
            </div>
          </div>
        </div>

        <div *ngIf="this.currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
          <div class="w-100">
            <p>Geolocation</p>
          </div>
          <div style="position: relative;" class="row">
            <div class="choose-window">
              <p>Off</p>
              <label class="switch">
                <input type="checkbox" name="geoLocationEnabled" ngModel>
                <span class="slider round"></span>
              </label>
              <p>Allow</p>
            </div>
          </div>
        </div>


        <!-- LOGO -->
      <div *ngIf="!subcustomer" class="form-group">
        <div class="d-flex justify-content-between mb-4">
          <div>
            Logo
          </div>
          <div style="width: 100px;">
            <input type="file" id="logo" style="display: none;" (change)="getFile($event)">
            <div>
              <div class="upload_container" (click)="chooseLogo()">
                Upload Logo
              </div>
            </div>
            <div *ngIf="previewLogo">
              <img style="cursor: pointer;" class="img-fluid" [src]="previewLogo" (click)="chooseLogo()" alt="logo">
            </div>
          </div>
        </div>
      </div>

        <button type="submit" class="custom-button" style="width: 120px;" translate>global.save</button>
      </form>
    </div>
  </div>
</ng-template>